export default page => {
  const { layouts } = page;

  return Object.values(layouts).reduce((layoutAccumulator, layout) => {
    const groupsData = Object.values(layout.groups).reduce((groupAccumulator, group) => {
      const shieldsData = Object.values(group.shields).reduce((shieldAccumulator, shield) => {
        return { ...shieldAccumulator, [shield.id]: shield };
      }, {});
      return { ...groupAccumulator, ...shieldsData };
    }, {});
    return { ...layoutAccumulator, ...groupsData };
  }, {});
};
